var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFasong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58 8L1.843 2.153a.5.5 0 01.716-.583l11.123 5.99a.5.5 0 010 .88L2.56 14.43a.5.5 0 01-.716-.583L3.58 8zm0 0H6.7",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNTggOEwxLjg0MjU1IDIuMTUyODNDMS43MTU4NSAxLjcyNjQzIDIuMTY3MjQgMS4zNTkyOCAyLjU1ODg5IDEuNTcwMTdMMTMuNjgyNCA3LjU1OTc2QzE0LjAzMyA3Ljc0ODU1IDE0LjAzMyA4LjI1MTQ1IDEzLjY4MjQgOC40NDAyNEwyLjU1ODg5IDE0LjQyOThDMi4xNjcyNCAxNC42NDA3IDEuNzE1ODUgMTQuMjczNiAxLjg0MjU1IDEzLjg0NzJMMy41OCA4Wk0zLjU4IDhINi43IiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgTongyongFasong as ReactComponent };